import { PositionBalanceWksComponent } from './business/position-balance-wks/position-balance-wks.component';
import { BilletRootComponent } from './business/billet-root/billet-root.component';
import { OrderWksComponent } from './business/order-wks/order-wks.component';
import { PositionDayWksComponent } from './business/position-day-wks/position-day-wks.component';
import { HighLowDayComponent } from './business/high-low-day/high-low-day.component';
import { NewsWksComponent } from './business/news-wks/news-wks.component';
import { BilletWksComponent } from './business/billet-wks/billet-wks.component';
import { BilletQuickComponent } from './business/billet-quick/billet-quick.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth/auth.guard';
import { AssetSummaryComponent } from '@business/asset-summary/asset-summary.component';
import { BookControllerComponent } from '@business/book/book.controller';
import { LoginComponent } from '@business/login/login.component';
import { OrdersHistoryComponent } from '@business/orders-history/orders-history.component';
import { TimesTradesComponent } from '@business/times-trades/times-trades.component';
import { VolumeAtPriceComponent } from '@business/volume-at-price/volume-at-price.component';
import { WorksheetComponent } from '@business/worksheet/worksheet.component';
import { ErrorScreenComponent } from '@component/error-screen/error-screen.component';
import { YoutubeLiveComponent } from '@component/youtube-live/youtube-live.component';
import { RecoverPasswordComponent } from '@business/recover-password/recover-password.component';
import { CedroViewGuard } from '@auth/cedro-view.guard';
import { DictionaryErrorComponent } from '@business/dictionary-error/dictionary-error.component';
import { RankingViewGuard } from '@auth/ranking-view-guard';
import { OnboardingViewGuard } from '@auth/onboarding-view-guard';
import { TradingViewComponent } from '@shared/components/trading-view/trading-view.component';

const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./business/home/home.module').then(m => m.HomeModule) },
  { path: 'register', loadChildren: () => import('./register/register.module').then(m=> m.RegisterModule), canActivate: [CedroViewGuard] },
  { path: 'ciclo-investimentos/register', loadChildren: () => import('./register/register.module').then(m => m.RegisterModule), canActivate: [RankingViewGuard] },
  { path: 'onboarding', loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule), canActivate: [OnboardingViewGuard] },
  // { path: 'chart', component: TradingViewComponent, canActivate: [AuthGuard] },
  { path: 'chart', loadChildren: () => import('./modules/chart/chart.module').then(m => m.ChartModule) },
  { path: 'timestrades', component: TimesTradesComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'recoverPassword', component: RecoverPasswordComponent },
  { path: 'logout', component: LoginComponent },
  { path: 'asset-summary', component: AssetSummaryComponent, canActivate: [AuthGuard] },
  // { path: 'styleguide', component: StyleguideComponent },
  { path: 'book', component: BookControllerComponent, canActivate: [AuthGuard] },
  { path: 'worksheet', component: WorksheetComponent, canActivate: [AuthGuard] },
  { path: 'volume-at-price', component: VolumeAtPriceComponent, canActivate: [AuthGuard] },
  { path: 'history', component: OrdersHistoryComponent, canActivate: [AuthGuard] },
  { path: 'error', component: ErrorScreenComponent },
  { path: 'live', component: YoutubeLiveComponent, canActivate: [AuthGuard] },
  { path: 'billet-root', component: BilletQuickComponent, canActivate: [AuthGuard] },
  { path: 'news-wks', component: NewsWksComponent, canActivate: [AuthGuard] },
  { path: 'high-low-day', component: HighLowDayComponent, canActivate: [AuthGuard] },
  { path: 'position-day', component: PositionDayWksComponent, canActivate: [AuthGuard] },
  { path: 'position-balance-wks', component: PositionBalanceWksComponent, canActivate: [AuthGuard] },
  { path: 'order-wks', component: OrderWksComponent, canActivate: [AuthGuard] },
  { path: 'error-dictionary', component: DictionaryErrorComponent },
  { path: '**', component: ErrorScreenComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, { useHash: false })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
